import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOverview = (props) => /* @__PURE__ */ _jsxs("g", { children: [
	/* @__PURE__ */ _jsx("rect", {
		x: .625,
		y: 9.02539,
		width: 10.7498,
		height: 14.3497,
		rx: 1.375,
		strokeWidth: 1.25
	}),
	/* @__PURE__ */ _jsx("rect", {
		x: 15.0234,
		y: .625,
		width: 10.7498,
		height: 14.3497,
		rx: 1.375,
		strokeWidth: 1.25
	}),
	/* @__PURE__ */ _jsx("rect", {
		x: .625,
		y: .625,
		width: 10.7498,
		height: 4.7499,
		rx: 1.375,
		strokeWidth: 1.25
	}),
	/* @__PURE__ */ _jsx("rect", {
		x: 15.0234,
		y: 18.625,
		width: 10.7498,
		height: 4.7499,
		rx: 1.375,
		strokeWidth: 1.25
	})
] });
export default SvgOverview;
